import React, { Component } from 'react';

import Row from '../components/row';
import Title from '../components/title';

export default class ContactInfo extends Component {

  constructor(props) {
    super(props);

    this.state = { pointerEvents: 'auto', cursor: 'pointer' };
    this.handleClick = this.handleClick.bind(this);
  }


  render() {
    const { pointerEvents, cursor } = this.state;
    const style = { 'pointer-events': pointerEvents, cursor };
    return (
      <Row>
        <Title title="Contacto" />
        <div className="col-lg-12 mt30 text-center">
          <p>Whatsapp: <strong>+598 9206 0006</strong></p>
          <p>Email: <strong><a href="mailto:elcapullohotel@gmail.com">elcapullohotel@gmail.com</a></strong></p>
          <p>Dirección: <strong>18 de Julio 219, Colonia del Sacramento</strong></p>
        </div>
        <div className="col-lg-12 mt30">
          <div className="map-overlay" style={style} onClick={this.handleClick} />
          <iframe width="100%" height="400" frameBorder="0" scrolling="no" marginHeight="0" marginWidth="0" src="https://www.google.com/maps/embed/v1/place?key=AIzaSyDsUm8uVkN0ogglYO2jtZzpLIxQiGwk2Vo&q=Posada+el+capullo+,+Colonia"></iframe>
        </div>
        <div className="clearfix"></div>
      </Row>
    );
  }

  handleClick() {
    this.setState({ pointerEvents: 'none', cursor: 'move' });
  }

};



// WEBPACK FOOTER //
// ./src/contact/contact-info.js